import { Injectable } from '@angular/core';
import { Ride } from '@models/ride';
import { PusherService } from './pusher.service';
import { Subject, Subscription } from 'rxjs';

const RIDE_PUSHER_EVENT_NAME = 'ride';

@Injectable({
  providedIn: 'root',
})
export class RidesPusherService {
  pusherChannelSubscription: Subscription;
  onRideUpdated: Subject<number> = new Subject();
  onRideApprovedOrRejected: Subject<Ride> = new Subject();
  isDemo = window.location.href.includes('demo.drvn');

  constructor(private readonly pusherService: PusherService) {}

  async subscribeToRidesPusherChannel() {
    if (this.pusherChannelSubscription) return;
    const suscription = await this.pusherService.subscribeEvent<{ ride_id: number }>(RIDE_PUSHER_EVENT_NAME, true);
    suscription.subscribe(async ({ ride_id }) => {
      try {
        if (!ride_id) return;
        this.onRideUpdated.next(ride_id);
      } catch (error) {}
    });
  }

  unsubscribeToRidesPusherChannel() {
    this.pusherChannelSubscription?.unsubscribe();
    this.pusherChannelSubscription = null;
  }
}
